<h3>
    <a ng-click="viewDetails($event, item)" ng-bind-html="item.name|cHighlight:highlight"></a>
</h3>
<div class="property-container">
    <ul class="workflow-property-list">
        <li>{{::'admin.organization.connected.workunits'|translate}}: {{item.workUnitCount}}</li>
        <li>{{::'admin.organization.connected.users'|translate}}: {{item.userCount}}</li>
    </ul>
</div>
